var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agent-status-badge",on:{"click":_vm.toggleDrawer}},[_c('span',[_vm._v(_vm._s(_vm.agentStatus))]),_vm._v(" "),_c('i',{staticClass:"icon"},[_vm._v("ℹ️")])])
}
var staticRenderFns = []

export { render, staticRenderFns }